import React from 'react';
import AIcon from 'antd-mobile/lib/icon';



export default class Icon extends AIcon {}